import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Typography,
  Popover,
  Input,
  message,
  Menu,
  Tooltip,
  Spin,
  Modal,
  Dropdown,
  Button,
  Space,
  InputRef,
  Select,
} from 'antd';
import { ProFormCheckbox, ProFormSelect } from '@ant-design/pro-form';
import ProForm from '@ant-design/pro-form';
import AttributeList from '../compontents/attribute-list';
import classnames from 'classnames';
import * as api from '@/services/rule';
import { getObjectList } from '../../../services/object-rule';
import { getPrePropList } from '../../../services/props';
import {
  EmptyFileColor,
  Add,
  WarmingCircle,
  AlertFilled,
  More,
  DoubtCircle,
  Close,
} from 'patternx-svg';
import { cloneDeep, remove, endsWith, trimEnd } from 'lodash';
import moment from 'moment';
import { validateRule } from './utils';

import './index.less';

const { Title } = Typography;
const { TextArea } = Input;

const compareKeys = [
  { label: '族类别名称', value: '1' },
  { label: '族名称', value: '2' },
  { label: '族类型', value: '3' },
];

const compareTypes = [
  { label: '大于', value: '大于' },
  { label: '小于', value: '小于' },
  { label: '大于等于', value: '大于等于' },
  { label: '小于等于', value: '小于等于' },
  { label: '等于', value: '等于' },
];

const Rules: React.FC<{}> = () => {
  const navigate = useNavigate();
  const [rules, setRules] = useState<RuleItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentRule, setCurrentRule] = useState<RuleItem>({} as RuleItem); // 当前的规则配置
  const [directionDicts, setDirectionDicts] = useState<{ label: string; value: string }[]>([]);
  const [selectedKey, setSelectedKey] = useState<string>('');
  const [currentRuleIsChanged, setCurrentRuleIsChanged] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [objects, setObjects] = useState<presetObjectItem[]>([]);
  const [isLoadingObject, setIsLoadingObject] = useState(false);
  const formRef1 = useRef<any>();
  const inputRef = useRef<InputRef>(null);
  const [propLists, setPropLists] = useState<{ label: string; value: string }[]>([]);
  const [conditions, setConditions] = useState<ruleCondition[]>([]);

  const getPropList = async () => {
    const res = await getPrePropList();
    setIsLoading(false);
    const lists = res?.data?.details?.filter((d: preProp) => d.published);
    const props = lists?.map(
      (r: any) =>
        ({
          value: JSON.stringify(r),
          label: r.name,
        } || []),
    );
    setPropLists(props);
    return lists;
  };

  const setDefaultConditions = async (r: RuleItem) => {
    const lists = await getPropList();
    const conditionDTOList = (r.conditionDTOList || [])?.map((c) => {
      const val = JSON.stringify(lists?.find((p: ruleCondition) => p.id === c.compareKey));
      return {
        ...c,
        compareKeyValue: val || '',
      };
    });
    setConditions(conditionDTOList);
  };

  const addDefautCondion = (rule: RuleItem) => {
    if (rule.type === 3 && (!rule.conditionDTOList || rule?.conditionDTOList?.length === 0)) {
      rule.conditionDTOList = [
        {
          id: `id_${new Date().getTime()}`,
          compareKey: undefined,
          compareType: undefined,
          compareValue: '',
        },
      ];
    }
  };

  const getRuleDetail = async (rule: RuleItem) => {
    if (!isLoading) {
      setIsLoading(true);
    }
    const res = await api.getRuleDetail(rule?.id || '');
    if (res?.success) {
      const cRule = validateRule(res?.data?.details) || res?.data?.details;
      addDefautCondion(cRule);
      setCurrentRule(cRule);
      if (cRule.type === 3) {
        setDefaultConditions(cRule);
        setConditions(cRule?.conditionDTOList || []);
      } else {
        setIsLoading(false);
      }
    } else {
      addDefautCondion(rule);
      setCurrentRule(rule);
      if (rule.type === 3) {
        setDefaultConditions(rule);
        setConditions(rule?.conditionDTOList || []);
      } else {
        setIsLoading(false);
      }
    }
  };

  const getRules = async (params?: { isReset?: boolean; id?: string }) => {
    setIsLoading(true);
    const res = await api.getRules();
    if (res?.success) {
      const ruleDTOList = res?.data?.details?.ruleDTOList || [];
      const lists = ruleDTOList?.map((r: RuleItem) => {
        return {
          ...(validateRule(r) || r),
          checked: r.published,
          disableChecked: r.template,
        };
      });
      if (lists?.length > 0) {
        setRules(lists);
        let flag = false;
        if (params?.id) {
          const rule = lists?.find((r: RuleItem) => r?.id === params.id);
          if (rule) {
            getRuleDetail(rule);
            setSelectedKey(rule.id);
          } else {
            flag = true;
          }
        } else if (currentRule?.id && !params?.isReset && currentRule.id !== 'newRule') {
          getRuleDetail(currentRule);
          setSelectedKey(currentRule.id);
        } else {
          flag = true;
        }
        if (flag) {
          getRuleDetail(lists[0]);
          setSelectedKey(lists[0]?.id);
        }
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const getDirectionDict = async () => {
    const res = await api.getDirectionTypeDicts('check.conflict.rule.direction.type');
    const dicts = res?.data?.dicts?.map(
      (r: any) =>
        ({
          value: r.code,
          label: r.name,
        } || []),
    );
    setDirectionDicts(dicts);
  };

  useEffect(() => {
    getRules();
    getDirectionDict();
  }, []);

  const getexamObjectStr = (presetObjectList: objectItemDto[]) => {
    const names = [...presetObjectList]?.map((v) => v.examineObjectName);
    return `${names?.join('、')}`;
  };

  const examObject = useMemo(() => {
    const leftObjectDTO = currentRule?.leftObjectDTO || ({} as objectDto);
    const rightObjectDTO = currentRule?.rightObjectDTO || ({} as objectDto);
    return {
      left: getexamObjectStr(leftObjectDTO?.presetObjectList || []),
      right: getexamObjectStr(rightObjectDTO?.presetObjectList || []),
    };
  }, [currentRule]);

  const presetDetail = (item: any) => {
    const details = JSON.parse(item?.value || '{}') as presetObjectItem;
    return (
      <div className="grey6 w240">
        <div>满足以下{details?.conditionRelation}条件：</div>
        {details?.conditions?.map((c) => (
          <div key={c.id}>
            {`${compareKeys?.find((k) => k?.value === c?.compareKey)?.label} ${c?.compareType} ${
              c?.compareValue
            }`}
            ；
          </div>
        ))}
      </div>
    );
  };

  const prePropDetail = (item: any) => {
    const details = JSON.parse(item?.value || '{}') as preProp;
    return (
      <div className="grey6 w240">
        <div>满足以下{details?.conditionRelation || '所有'}条件：</div>
        {details?.conditions?.map((c) => (
          <div key={c.id}>{`属性名称 ${c?.compareType} ${c?.compareValue}`}；</div>
        ))}
      </div>
    );
  };

  const setSelectPresets = (type: string, lists: presetObjectItem[], rule?: RuleItem) => {
    const selects = (rule || currentRule)?.[type + 'ObjectDTO'];
    const selectSelectorIds = selects?.presetObjectList?.map(
      (s: objectItemDto) => s?.examineObjectId,
    );
    const selectSelectors = lists
      ?.filter((l: any) => selectSelectorIds?.includes(l?.id))
      ?.map((l: presetObjectItem) => JSON.stringify(l));
    formRef1.current.setFieldsValue({ presets: selectSelectors });
  };

  const getObjects = async (type: string) => {
    setIsLoadingObject(true);
    const res = await getObjectList();
    setIsLoadingObject(false);
    if (res?.success) {
      const lists = (res?.data?.details?.preObjectList || [])?.filter(
        (p: presetObjectItem) => p?.published,
      );
      setObjects(lists);
      setSelectPresets(type, lists);
    }
  };

  const popoverContent = (type: string, title?: string) => {
    const sType = type?.toLowerCase();
    return (
      <div className="popoverContent">
        <div className="popTitle">
          <span>{title || `审查对象${sType === 'left' ? 1 : 2}`}</span>
        </div>
        <div className="label">
          预设对象
          <Tooltip
            title="可作为审查对象被规则引用，快速形成规则要求，对象内容可以在对象管理中维护。"
            placement="top"
          >
            <DoubtCircle className={classnames('grey5', 'ml4')} size={16} />
          </Tooltip>
        </div>
        <ProForm formRef={formRef1} submitter={false}>
          <ProFormSelect
            // request={async () => {
            //   const res = await getObjectList();
            //   if (res?.success) {
            //     const lists = (res?.data?.details?.preObjectList || [])?.filter(
            //       (p: presetObjectItem) => p?.published,
            //     );
            //     setObjects(lists);
            //     setSelectPresets(sType, lists);
            //     return (
            //       lists?.map((r: any) => ({
            //         value: JSON.stringify(r),
            //         label: r.name,
            //       })) || []
            //     );
            //   }
            //   return [];
            // }}
            options={
              objects?.map((o) => {
                return {
                  value: JSON.stringify(o),
                  label: o.name,
                };
              }) || []
            }
            name="presets"
            placeholder={'选择预设对象'}
            label={false}
            fieldProps={{
              loading: isLoadingObject,
              showArrow: true,
              onChange: (values) => {
                setCurrentRuleIsChanged(true);
                const selectors = values
                  ?.map((v: string) => JSON.parse(v))
                  ?.map((v: any) => {
                    return {
                      examineObjectId: v.id,
                      examineObjectName: v.name,
                      examineObjectPath: '',
                      examineObjectType: 2,
                      examineObjectVersionId: '',
                      origin: sType,
                    };
                  });
                setCurrentRule({
                  ...currentRule,
                  [sType + 'ObjectDTO']: {
                    ...currentRule[sType + 'ObjectDTO'],
                    presetObjectList: [...selectors],
                  },
                });
              },
              notFoundContent: (
                <div className="noContentWrap">
                  <div>
                    <EmptyFileColor size={80} />
                  </div>
                  <div className="emptyTitle">没有预设对象</div>
                  <div className="emptyDesc">
                    前往
                    <span
                      className="emptyBtn"
                      onClick={() => {
                        navigate('/rule-config/objects');
                      }}
                    >
                      对象管理
                    </span>
                    配置
                  </div>
                </div>
              ),
              optionItemRender(item) {
                return (
                  <Popover
                    content={() => presetDetail(item)}
                    title=""
                    mouseEnterDelay={0.3}
                    placement="right"
                    overlayClassName="examObjectPopoverWrap"
                    // visible={true}
                  >
                    <div style={{ width: 230 }}>{item.label}</div>
                  </Popover>
                );
              },
            }}
            mode="multiple"
          />
        </ProForm>
      </div>
    );
  };

  const isHasAddingRule = useMemo(() => {
    return rules?.find((r) => r?.isNew);
  }, [rules]);

  const onConfirm = (params: {
    fn: Function;
    title: string;
    content: string;
    okText: string;
    cancelText: string;
    danger: boolean;
  }) => {
    Modal.confirm({
      title: params.title,
      icon: <AlertFilled className="clearFilledIcon" />,
      content: params.content,
      okText: params.okText,
      cancelText: params.cancelText,
      centered: true,
      wrapClassName: 'confirmModal',
      okButtonProps: {
        danger: params.danger,
      },
      onOk: async () => {
        params.fn();
      },
    });
  };

  const onDelete = (record: any) => {
    onConfirm({
      fn: async () => {
        const res = await api.deleteRule(record?.id || '');
        if (res?.success && currentRule?.id === record?.id) {
          setCurrentRule({} as RuleItem);
          getRules({ isReset: true });
        } else {
          getRules();
        }
      },
      title: '确认删除规则吗？',
      content: '删除后所有用户将不可使用此规则发起新审查。',
      okText: '删除',
      cancelText: '再想想',
      danger: true,
    });
  };

  const handleChecked = async (record: any, checked: boolean) => {
    setRules(rules.map((item) => (item.id === record.id ? { ...item, checked } : item)));
    const res = await api.publishRule({
      published: checked,
      ruleId: record?.id,
    });
    if (res?.success && checked) {
      message.success('发布成功');
    }
    getRules();
  };

  const selectRule = (record: RuleItem) => {
    setSelectedKey(record.id || '');
    addDefautCondion(record);
    setCurrentRule(record);
    getRuleDetail(record);
    setCurrentRuleIsChanged(false);
    remove(rules, (r) => r.id === 'newRule');
    setRules([...rules]);
    setConditions(record?.conditionDTOList || []);
    setIsAdding(false);
    setIsEditing(false);
  };

  const handleSelect = (record: any, fn?: Function) => {
    const callback =
      fn ||
      (() => {
        selectRule(record);
      });
    if (currentRuleIsChanged || isHasAddingRule) {
      onConfirm({
        fn: callback,
        title: isHasAddingRule ? '确认放弃本次新增吗？' : '确认放弃本次修改吗？',
        content: isHasAddingRule ? '放弃后将不会新增此规则。' : '放弃后将不保留未保存的内容。',
        okText: '放弃',
        cancelText: '关闭',
        danger: false,
      });
    } else {
      callback(record);
    }
  };

  const onCopy = async (record: any) => {
    const res = await api.copyRule(record?.id || '');
    if (res?.success) {
      message.success('复制成功');
    }
    getRules();
  };

  const copyRule = async (record: any) => {
    if (isHasAddingRule || currentRuleIsChanged) {
      handleSelect(record, () => {
        onCopy(record);
        setCurrentRuleIsChanged(false);
      });
      return;
    }
    onCopy(record);
  };

  const dropdownOverlay = (record: any) => {
    return (
      <Menu style={{ width: 80 }}>
        <Menu.Item key="copy" onClick={() => copyRule(record)}>
          复制
        </Menu.Item>
        {!record?.template && !record?.published && (
          <Menu.Item key="delete">
            <div className="color-error" onClick={() => onDelete(record)}>
              删除
            </div>
          </Menu.Item>
        )}
      </Menu>
    );
  };

  const handleAdd = (type: number) => {
    const targetRule = rules?.find((r) => r?.type === type && r.template);
    if (isHasAddingRule) {
      Modal.warning({
        title: '有未保存的新规则，请取消或保存后再新增',
        content: '',
      });
      return;
    }
    if (currentRuleIsChanged) {
      handleSelect(targetRule, () => {
        handleAdd(type);
        setCurrentRuleIsChanged(false);
      });
      return;
    }
    if (propLists?.length === 0) {
      getPropList();
    }
    const newCondition = {
      id: `id_${new Date().getTime()}`,
      compareKey: '',
      compareType: undefined,
      compareValue: '',
    };
    const rule: RuleItem = {
      leftObjectDTO: {
        presetObjectList: [],
      },
      rightObjectDTO: {
        presetObjectList: [],
      },
      directionType: '',
      directionValue: 0,
      exclude: 'same_obj_no_check',
      mark: '',
      name: '未命名规则',
      originId: targetRule?.id || '',
      tolerateDiff: 0,
      type: type,
      isNew: true,
      id: 'newRule',
      conditionDTOList: type === 3 ? [{ ...newCondition }] : undefined,
    };
    setRules((r) => {
      return [...r, { ...rule }];
    });
    setCurrentRule({ ...rule });
    setSelectedKey('newRule');
    setTimeout(() => {
      inputRef.current!.focus({
        cursor: 'all',
      });
    }, 100);
    setConditions(type === 3 ? [{ ...newCondition }] : []);
  };

  const addRuleOverlay = (
    <Menu style={{ width: 110 }}>
      <Menu.Item key="rule1" onClick={() => handleAdd(1)}>
        硬碰撞规则
      </Menu.Item>
      <Menu.Item key="rule2" onClick={() => handleAdd(2)}>
        软碰撞规则
      </Menu.Item>
      <Menu.Item key="rule3" onClick={() => handleAdd(3)}>
        属性判断规则
      </Menu.Item>
    </Menu>
  );

  const handleEdit = async () => {
    if (isEditing) {
      return;
    }
    setIsEditing(true);
    const needValidateRule = {
      ...currentRule,
      conditionDTOList: conditions,
    };
    const isInvalidate = validateRule(needValidateRule);
    // console.log(needValidateRule, isInvalidate, '===123');
    if (isInvalidate) {
      message.error('有审查规则未设置');
      setCurrentRule({ ...isInvalidate });
      setConditions([...(isInvalidate.conditionDTOList || [])]);
      setIsEditing(false);
      return;
    }
    const res = await api.editRule({
      id: currentRule.id,
      name: currentRule.name,
      detailLeftDTOList: currentRule.leftObjectDTO?.presetObjectList || [],
      detailRightDTOList: currentRule.rightObjectDTO?.presetObjectList || [],
      directionType: currentRule.directionType,
      directionValue: currentRule.directionValue,
      exclude: currentRule.exclude,
      tolerateDiff: currentRule.tolerateDiff,
      mark: currentRule.mark,
      originId: currentRule.originId || currentRule.id,
      type: currentRule.type,
      syncToLib: true,
      updatedAt: currentRule?.updatedAt ? moment(currentRule.updatedAt).valueOf() : null,
      conditionRelation: currentRule?.type === 3 ? '所有' : '',
      conditionDTOList: conditions,
    });
    setIsEditing(false);
    if (res?.success) {
      message.success('保存成功');
      const rule = res?.data?.details;
      setCurrentRuleIsChanged(false);
      await getRules({ id: rule?.id || '' });
    }
  };

  const cancelAddRule = () => {
    if (currentRuleIsChanged) {
      handleSelect(currentRule, () => {
        setCurrentRule({} as RuleItem);
        setSelectedKey('');
        setCurrentRuleIsChanged(false);
        getRules({ isReset: true });
      });
    } else {
      setCurrentRule({} as RuleItem);
      setSelectedKey('');
      setCurrentRuleIsChanged(false);
      getRules({ isReset: true });
    }
  };

  const onAddRule = async () => {
    if (isAdding) {
      return;
    }
    setIsAdding(true);
    const needValidateRule = {
      ...currentRule,
      conditionDTOList: conditions,
    };
    const isInvalidate = validateRule(needValidateRule);
    if (isInvalidate) {
      message.error('有审查规则未设置');
      setCurrentRule({ ...isInvalidate });
      setConditions([...(isInvalidate.conditionDTOList || [])]);
      setIsAdding(false);
      return;
    }
    const addRes = await api.addRule({
      name: currentRule.name,
      detailLeftDTOList: currentRule.leftObjectDTO?.presetObjectList || [],
      detailRightDTOList: currentRule.rightObjectDTO?.presetObjectList || [],
      directionType: currentRule.directionType,
      directionValue: currentRule.directionValue,
      exclude: currentRule.exclude,
      tolerateDiff: currentRule.tolerateDiff,
      mark: currentRule.mark,
      originId: currentRule.originId || currentRule.id,
      type: currentRule.type,
      conditionRelation: currentRule?.type === 3 ? '所有' : '',
      conditionDTOList: conditions,
    });
    setIsAdding(false);
    if (addRes?.success) {
      message.success('新增成功');
      const rule = addRes?.data?.details;
      setCurrentRuleIsChanged(false);
      await getRules({ id: rule?.id || '' });
    }
  };

  const addFn = () => {
    const condition = {
      id: `id_${new Date().getTime()}`,
      compareKey: '',
      compareType: undefined,
      compareValue: '',
    };
    setCurrentRule((r) => {
      return {
        ...r,
        conditionDTOList: [...(r.conditionDTOList || []), condition],
      };
    });
    setConditions((c) => {
      return [...c, condition];
    });
  };

  const removeFn = (c: ruleCondition) => {
    setCurrentRule((r) => {
      remove(r.conditionDTOList || [], (d) => d.id === c.id);
      return {
        ...r,
        conditionDTOList: r.conditionDTOList,
      };
    });
    setConditions((con) => {
      remove(con || [], (d) => d.id === c.id);
      return [...con];
    });
  };

  return (
    <Spin spinning={isLoading}>
      <div className="rule-wrap">
        <div className="page-header">规则管理</div>
        <div className="page-content">
          <div className="page-content-left">
            <div className="attribute-header">
              <div className="attribute-header-title">预设规则</div>
              <Tooltip title="新增规则" placement="top">
                <Dropdown trigger={['click']} overlay={addRuleOverlay}>
                  <Add className="attribute-header-icon" />
                </Dropdown>
              </Tooltip>
            </div>
            <AttributeList
              data={rules}
              selectedKey={selectedKey}
              dropdownOverlay={dropdownOverlay}
              onChecked={handleChecked}
              onSelect={handleSelect}
            />
          </div>
          <div className="page-content-right">
            {currentRule?.id && (
              <>
                <div className="flex-jc-ai-between">
                  <Title
                    level={4}
                    ellipsis={true}
                    style={{ margin: 0, marginRight: 24, minWidth: 150, lineHeight: 1 }}
                    title={currentRule.name}
                  >
                    <span className="text-grey-7-18" style={{ fontWeight: 600 }}>
                      {currentRule.name}
                    </span>
                  </Title>
                  {currentRule?.isNew ? (
                    <Space size={12}>
                      <Button key="cancelBtn" onClick={cancelAddRule}>
                        取消
                      </Button>
                      <Button key="addSaveBtn" type="primary" onClick={onAddRule}>
                        保存
                      </Button>
                    </Space>
                  ) : currentRule?.template ? (
                    <Button key="copyBtn" onClick={() => onCopy(currentRule)}>
                      复制
                    </Button>
                  ) : (
                    <Space size={16} align="end">
                      <Button key="editSaveBtn" type="primary" onClick={handleEdit}>
                        保存
                      </Button>
                      <Dropdown trigger={['click']} overlay={() => dropdownOverlay(currentRule)}>
                        <More className="operate-more" />
                      </Dropdown>
                    </Space>
                  )}
                </div>
                {!currentRule?.template && (
                  <>
                    <div className={classnames('title', 'mt24')}>规则名称</div>
                    <Input
                      placeholder="输入规则名称"
                      allowClear
                      value={currentRule.name}
                      status={currentRule?.nameStatus}
                      ref={inputRef}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setCurrentRule((current) => ({
                          ...current,
                          name: e.target.value?.trim(),
                        }));
                        setCurrentRuleIsChanged(true);
                      }}
                      onFocus={() => {
                        setCurrentRule((r) => {
                          return {
                            ...r,
                            nameStatus: '',
                          };
                        });
                      }}
                      maxLength={255}
                    />
                  </>
                )}
                <div style={{ marginTop: 24 }}>
                  <div className="title">检查要求</div>
                  {currentRule.type === 1 && currentRule?.template && (
                    <Space>
                      <Typography className="secondary-name">审查对象1</Typography>
                      <Typography>和</Typography>
                      <Typography className="secondary-name">审查对象2</Typography>
                      <Typography>参与碰撞检查。</Typography>
                    </Space>
                  )}
                  {currentRule.type === 2 && currentRule?.template && (
                    <Space>
                      <Typography className="secondary-name">审查对象1</Typography>
                      <Typography>的</Typography>
                      <Typography className="secondary-name">某方向</Typography>
                      <Typography className="secondary-name">某数值</Typography>
                      <Typography>范围内，不和</Typography>
                      <Typography className="secondary-name">审查对象2</Typography>
                      <Typography>发生碰撞。</Typography>
                    </Space>
                  )}
                  {currentRule.type === 3 && currentRule?.template && (
                    <>
                      <Space>
                        <Typography className="secondary-name">审查对象</Typography>
                        <Typography>满足以下条件：</Typography>
                      </Space>
                      <Space className="mt16">
                        <Typography className="secondary-name">某属性</Typography>
                        <Typography className="secondary-name">
                          某比较方式（例如大于、小于…）
                        </Typography>
                        <Typography className="secondary-name">某数值</Typography>
                      </Space>
                    </>
                  )}
                  {currentRule.type === 1 && !currentRule?.template && (
                    <>
                      <Popover
                        placement="left"
                        // mouseEnterDelay={0.3}
                        trigger="click"
                        title={''}
                        content={() => popoverContent('Left')}
                        destroyTooltipOnHide={true}
                        autoAdjustOverflow={false}
                        overlayClassName="examObjectPopoverWrap"
                        // visible={true}
                        onVisibleChange={(vis) => {
                          if (vis) {
                            getObjects('left');
                          }
                        }}
                      >
                        <Typography
                          className={classnames('rule-obj-name', 'cursor_pointer', {
                            'rule-obj-name_error': !examObject?.left,
                          })}
                        >
                          审查对象1
                          {examObject?.left ? (
                            '：' + examObject?.left
                          ) : (
                            <WarmingCircle size={20} className="ml4" />
                          )}
                        </Typography>
                      </Popover>
                      <Typography
                        className={classnames('display-inline-block', 'ml8', 'mr8', 'lineHeight30')}
                      >
                        和
                      </Typography>
                      <Popover
                        placement="left"
                        // mouseEnterDelay={0.3}
                        trigger="click"
                        title={''}
                        content={() => popoverContent('Right')}
                        destroyTooltipOnHide={true}
                        autoAdjustOverflow={false}
                        overlayClassName="examObjectPopoverWrap"
                        onVisibleChange={(vis) => {
                          if (vis) {
                            getObjects('right');
                          }
                        }}
                      >
                        <Typography
                          className={classnames('rule-obj-name', 'cursor_pointer', 'mr8', {
                            'rule-obj-name_error': !examObject?.right,
                          })}
                        >
                          审查对象2
                          {examObject?.right ? (
                            '：' + examObject?.right
                          ) : (
                            <WarmingCircle size={20} className="ml4" />
                          )}
                        </Typography>
                      </Popover>
                      <Typography className={classnames('display-inline-block', 'lineHeight30')}>
                        参与碰撞检查。
                      </Typography>
                    </>
                  )}
                  {currentRule.type === 2 && !currentRule?.template && (
                    <div>
                      <Popover
                        placement="left"
                        // mouseEnterDelay={0.3}
                        trigger="click"
                        title={''}
                        content={() => popoverContent('Left')}
                        destroyTooltipOnHide={true}
                        autoAdjustOverflow={false}
                        overlayClassName="examObjectPopoverWrap"
                        onVisibleChange={(vis) => {
                          if (vis) {
                            getObjects('left');
                          }
                        }}
                      >
                        <Typography
                          className={classnames('rule-obj-name', 'cursor_pointer', {
                            'rule-obj-name_error': !examObject?.left,
                          })}
                        >
                          审查对象1
                          {examObject?.left ? (
                            '：' + examObject?.left
                          ) : (
                            <WarmingCircle size={20} className="ml4" />
                          )}
                        </Typography>
                      </Popover>
                      <Typography className="display-inline-block ml8 mr8 lineHeight30">
                        的
                      </Typography>
                      <div className="display-inline-block mr8">
                        <ProFormSelect
                          options={directionDicts}
                          placeholder={'选择方向'}
                          fieldProps={{
                            size: 'small',
                            style: { width: 104 },
                            status: currentRule?.directionTypeStatus,
                            onChange: async (code: string) => {
                              setCurrentRule((current) => ({
                                ...current,
                                directionType: code || '',
                              }));
                              setCurrentRuleIsChanged(true);
                            },
                            onFocus: () => {
                              setCurrentRule((r) => {
                                return {
                                  ...r,
                                  directionTypeStatus: '',
                                };
                              });
                            },
                            value: currentRule.directionType || undefined,
                          }}
                          label={false}
                        />
                      </div>
                      <Input
                        placeholder="输入数值"
                        style={{ width: 120, marginRight: 8 }}
                        width={120}
                        suffix="mm"
                        size="small"
                        value={currentRule.directionValue}
                        status={currentRule?.directionValueStatus}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          if (!/^\d+$/.test(e.target.value) && e.target.value) {
                            message.info('请输入数字');
                            return;
                          }
                          setCurrentRule((current) => ({
                            ...current,
                            directionValue: e.target.value !== '' ? +e.target.value : '',
                          }));
                          setCurrentRuleIsChanged(true);
                        }}
                        onBlur={async (e: React.ChangeEvent<HTMLInputElement>) => {
                          if (!/^\d+$/.test(e.target.value)) {
                            message.info('请输入数字');
                            return;
                          }
                        }}
                        onFocus={() => {
                          setCurrentRule((r) => {
                            return {
                              ...r,
                              directionValueStatus: '',
                            };
                          });
                        }}
                      />
                      <Typography className="mr8 lineHeight30" style={{ display: 'inline' }}>
                        范围内，不和
                      </Typography>
                      <Popover
                        placement="left"
                        // mouseEnterDelay={0.3}
                        trigger="click"
                        title={''}
                        content={() => popoverContent('Right')}
                        destroyTooltipOnHide={true}
                        autoAdjustOverflow={false}
                        overlayClassName="examObjectPopoverWrap"
                        onVisibleChange={(vis) => {
                          if (vis) {
                            getObjects('right');
                          }
                        }}
                      >
                        <Typography
                          className={classnames('rule-obj-name', 'cursor_pointer', 'mr8', {
                            'rule-obj-name_error': !examObject?.right,
                          })}
                        >
                          审查对象2
                          {examObject?.right ? (
                            '：' + examObject?.right
                          ) : (
                            <WarmingCircle size={20} className="ml4" />
                          )}
                        </Typography>
                      </Popover>
                      <Typography className="lineHeight30" style={{ display: 'inline' }}>
                        发生碰撞。
                      </Typography>
                    </div>
                  )}
                  {currentRule.type === 3 && !currentRule?.template && (
                    <div>
                      <Popover
                        placement="left"
                        trigger="click"
                        title={''}
                        content={() => popoverContent('Left', '审查对象')}
                        destroyTooltipOnHide={true}
                        autoAdjustOverflow={false}
                        overlayClassName="examObjectPopoverWrap"
                        onVisibleChange={(vis) => {
                          if (vis) {
                            getObjects('left');
                          }
                        }}
                      >
                        <Typography
                          className={classnames('rule-obj-name', 'mr8', 'cursor_pointer', {
                            'rule-obj-name_error': !examObject?.left,
                          })}
                        >
                          审查对象
                          {examObject?.left ? (
                            '：' + examObject?.left
                          ) : (
                            <WarmingCircle size={20} className="ml4" />
                          )}
                        </Typography>
                      </Popover>
                      <Typography className={classnames('display-inline-block', 'lineHeight30')}>
                        的属性满足以下条件：
                      </Typography>
                    </div>
                  )}
                </div>
                {currentRule.type === 1 && (
                  <div style={{ marginTop: 24 }}>
                    <div className="title">对象排除</div>
                    {currentRule.template ? (
                      <Typography>同一个审查对象集合不检查</Typography>
                    ) : (
                      <ProFormCheckbox.Group
                        request={async () => {
                          const res = await api.getDirectionTypeDicts(
                            'check.conflict.rule.hard.exclude.type',
                          );
                          return (
                            res?.data?.dicts?.map((r: any) => ({
                              value: r.code,
                              label: r.name,
                            })) || []
                          );
                        }}
                        layout="vertical"
                        fieldProps={{
                          onChange: async (values) => {
                            setCurrentRule((current) => ({
                              ...current,
                              exclude: values?.join(','),
                            }));
                            setCurrentRuleIsChanged(true);
                          },
                          value: currentRule.exclude.split(','),
                        }}
                        label={false}
                      />
                    )}
                  </div>
                )}
                {currentRule.type !== 3 && (
                  <div style={{ marginTop: 24 }}>
                    <div className="title">容差</div>
                    {currentRule.template ? (
                      <div style={{ display: 'flex' }}>
                        <Typography
                          style={{
                            borderRadius: 4,
                            padding: '0 8px',
                          }}
                          className="secondary-name"
                        >
                          0 mm
                        </Typography>
                      </div>
                    ) : (
                      <div className="flex-jc-ai-start">
                        <Input
                          defaultValue={0}
                          style={{ width: 120 }}
                          width={120}
                          suffix="mm"
                          value={currentRule.tolerateDiff}
                          status={currentRule?.tolerateDiffStatus}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                            if (!/^\d+$/.test(e.target.value) && e.target.value) {
                              message.info('请输入数字');
                              return;
                            }
                            setCurrentRule((current) => ({
                              ...current,
                              tolerateDiff: e.target.value !== '' ? +e.target.value : '',
                            }));
                            setCurrentRuleIsChanged(true);
                          }}
                          onBlur={async (e: React.ChangeEvent<HTMLInputElement>) => {
                            if (!/^\d+$/.test(e.target.value)) {
                              message.info('请输入数字');
                              return;
                            }
                          }}
                          onFocus={() => {
                            setCurrentRule((r) => {
                              return {
                                ...r,
                                tolerateDiffStatus: '',
                              };
                            });
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
                {currentRule.type === 3 && !currentRule.template && (
                  <>
                    {(currentRule?.conditionDTOList || undefined)?.map((c, i) => (
                      <Space size={8} key={JSON.stringify(c)} className="mt12 flex">
                        <ProFormSelect
                          options={propLists}
                          fieldProps={{
                            status: conditions?.find((d) => d.id === c.id)?.compareKeyStatus,
                            showArrow: true,
                            showSearch: true,
                            style: { width: 200 },
                            value:
                              conditions?.find((d) => d.id === c.id)?.compareKeyValue || undefined,
                            onChange: (values) => {
                              const newVal = JSON.parse(values || '{}');
                              const allConditions = cloneDeep(conditions);
                              const cCondition = allConditions?.find((d) => d.id === c.id);
                              if (cCondition) {
                                cCondition.compareKeyValue = values;
                                cCondition.compareKey = newVal.id;
                                setConditions(allConditions);
                              }
                              setCurrentRuleIsChanged(true);
                            },
                            onFocus: () => {
                              const allConditions = cloneDeep(conditions);
                              const cCondition = allConditions?.find((d) => d.id === c.id);
                              if (cCondition) {
                                cCondition.compareKeyStatus = '';
                                setConditions(allConditions);
                              }
                            },
                            optionItemRender(item: any) {
                              return (
                                <Popover
                                  content={() => prePropDetail(item)}
                                  title=""
                                  mouseEnterDelay={0.3}
                                  placement="right"
                                  overlayClassName="examObjectPopoverWrap"
                                >
                                  <div style={{ width: 185 }}>{item.label}</div>
                                </Popover>
                              );
                            },
                            notFoundContent: (
                              <div className="noContentWrap">
                                <div>
                                  <EmptyFileColor size={80} />
                                </div>
                                <div className="emptyTitle">没有预设属性</div>
                                <div className="emptyDesc">
                                  前往
                                  <span
                                    className="emptyBtn"
                                    onClick={() => {
                                      navigate('/rule-config/props');
                                    }}
                                  >
                                    属性管理
                                  </span>
                                  配置
                                </div>
                              </div>
                            ),
                          }}
                          placeholder={'预设属性'}
                          name={`id${c.id}`}
                          label={false}
                        />
                        <Select
                          options={compareTypes}
                          placeholder="比较方式"
                          status={conditions?.find((d) => d.id === c.id)?.compareTypeStatus}
                          value={conditions?.find((d) => d.id === c.id)?.compareType || undefined}
                          onChange={(val) => {
                            const allConditions = cloneDeep(conditions);
                            const cCondition = allConditions?.find((d) => d.id === c.id);
                            if (cCondition) {
                              cCondition.compareType = val;
                              setConditions(allConditions);
                            }
                            setCurrentRuleIsChanged(true);
                          }}
                          onFocus={() => {
                            const allConditions = cloneDeep(conditions);
                            const cCondition = allConditions?.find((d) => d.id === c.id);
                            if (cCondition) {
                              cCondition.compareTypeStatus = '';
                              setConditions(allConditions);
                            }
                          }}
                          style={{ width: 104 }}
                        />
                        <Input
                          autoComplete="off"
                          name="compareValue"
                          placeholder="输入数值"
                          status={conditions?.find((d) => d.id === c.id)?.compareValueStatus}
                          value={conditions?.find((d) => d.id === c.id)?.compareValue}
                          onChange={(e) => {
                            const val = e.target.value;
                            const reg = /^-?\d+(\.\d{0,3})?$/;
                            setCurrentRuleIsChanged(true);
                            if (reg.test(val) || val === '' || val === '-') {
                              const allConditions = cloneDeep(conditions);
                              const cCondition = allConditions?.find((d) => d.id === c.id);
                              if (cCondition) {
                                cCondition.compareValue = val;
                                setConditions(allConditions);
                              }
                            }
                          }}
                          onBlur={(e) => {
                            let val = e.target.value;
                            if (val && endsWith(val, '.')) {
                              val = trimEnd(val, '.');
                              const allConditions = cloneDeep(conditions);
                              const cCondition = allConditions?.find((d) => d.id === c.id);
                              if (cCondition) {
                                cCondition.compareValue = val;
                                setConditions(allConditions);
                              }
                            }
                          }}
                          onFocus={() => {
                            const allConditions = cloneDeep(conditions);
                            const cCondition = allConditions?.find((d) => d.id === c.id);
                            if (cCondition) {
                              cCondition.compareValueStatus = '';
                              setConditions(allConditions);
                            }
                          }}
                          style={{ width: 100 }}
                        />
                        {/* <InputNumber
                          name="compareValue"
                          placeholder="输入数值"
                          controls={false}
                          keyboard={false}
                          status={conditions?.find((d) => d.id === c.id)?.compareValueStatus}
                          value={conditions?.find((d) => d.id === c.id)?.compareValue}
                          onChange={(val) => {
                            setCurrentRuleIsChanged(true);
                            const allConditions = cloneDeep(conditions);
                            const cCondition = allConditions?.find((d) => d.id === c.id);
                            if (cCondition) {
                              cCondition.compareValue = val;
                              setConditions(allConditions);
                            }
                          }}
                          onFocus={() => {
                            const allConditions = cloneDeep(conditions);
                            const cCondition = allConditions?.find((d) => d.id === c.id);
                            if (cCondition) {
                              cCondition.compareValueStatus = '';
                              setConditions(allConditions);
                            }
                          }}
                          style={{ width: 160 }}
                        /> */}
                        {i !== 0 && <Close className="close-icon" onClick={() => removeFn(c)} />}
                      </Space>
                    ))}
                    <div className="rule-prop-tips">
                      本规则中进行比较时采用的默认单位，长度类为mm，面积类为㎡
                    </div>
                    <Button
                      className="preProp-add-btn"
                      type="link"
                      onClick={
                        addFn
                        // add({ compareKey: '', compareType: '', compareValue: '' })
                      }
                      icon={<Add size={20} />}
                    >
                      添加条件
                    </Button>
                  </>
                )}
                <div style={{ marginTop: 24 }}>
                  <div className="title">描述</div>
                  {currentRule.template ? (
                    <Typography>通用{currentRule.name}规则</Typography>
                  ) : (
                    <TextArea
                      placeholder="填写规则描述"
                      allowClear
                      value={currentRule.mark}
                      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                        setCurrentRule((current) => ({
                          ...current,
                          mark: e.target.value,
                        }));
                        setCurrentRuleIsChanged(true);
                      }}
                      maxLength={255}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Rules;
